








































import { Component, Prop, Vue } from 'vue-property-decorator'

// Model
import BeaconModel from '@/_models/BeaconModel'
import CategoryModel from '@/_models/CategoryModel'

@Component({
  components: {},
})
export default class LegendTitle extends Vue {
  @Prop({ default: false }) isPlaceMode: boolean = false

  @Prop()
  beacons!: BeaconModel[]

  @Prop()
  categories!: CategoryModel[]

  @Prop()
  parseColor!: (str: string) => string

  isMinimizeLegend = false
}
